import { create } from 'zustand';

interface ClosureState {
  // Chantier en cours de clôture
  chantierId: string | null;
  // Date de fin réelle saisie
  dateFinReelle: string | null;
  // Indique si on a navigué vers le simulateur de retard depuis le modal de clôture
  fromClosureModal: boolean;

  // Actions
  startClosure: (chantierId: string, dateFinReelle: string) => void;
  clearClosure: () => void;
  setFromClosureModal: (value: boolean) => void;
}

export const useClosureStore = create<ClosureState>((set) => ({
  chantierId: null,
  dateFinReelle: null,
  fromClosureModal: false,

  startClosure: (chantierId, dateFinReelle) => set({
    chantierId,
    dateFinReelle,
    fromClosureModal: true,
  }),

  clearClosure: () => set({
    chantierId: null,
    dateFinReelle: null,
    fromClosureModal: false,
  }),

  setFromClosureModal: (value) => set({ fromClosureModal: value }),
}));
